import moment from "moment"
import Link from "next/link"
import Image from "next/image"
import { createObjectPagePathname, getMediaUrl, getAsServerMediaUrl } from "@/services/pathname"
import img from "@/assets/img/gallery/gallery-1.jpg"
import 'moment/locale/fr'
moment.locale('fr')
import { environments, getNextSessions } from "@/services/holidayStay"
import { getName } from "@/services/aroeven"


type CardProps = {
    holidayStay: HolidayStay,
    filters?: any
}

export default function Card({
    holidayStay,
    filters = null
}: CardProps) {

    const nextSessions = getNextSessions(holidayStay)
    const availableSessions = nextSessions.filter(s => s.availablePlaces > 0)
    const targetSessions = nextSessions.filter(s => {
        if (!filters) {
            return true
        }
        let minDate = moment()
        if (filters.minDate) {
            minDate = moment(filters.minDate, 'YYYY-MM-DD')
        }
        let maxDate = moment().add(99, 'years')
        if (filters.maxDate) {
            maxDate = moment(filters.maxDate.get('maxDate'), 'YYYY-MM-DD')
        }
        if (moment(s.startDate) > maxDate || moment(s.endDate) < minDate) {
            return false
        }
        if (filters.favorite) {
            return s.favorite === true
        }
        return true
    })
    targetSessions.sort((a, b) => {
        if (a.availablePlaces > 0 && b.availablePlaces === 0) return -1
        if (a.availablePlaces === 0 && b.availablePlaces > 0) return 1
        return a.startDate < b.startDate ? -1 : 1
    })
    const targetSession = targetSessions[0] ?? availableSessions[0] ?? nextSessions[0]

    const cities = targetSessions.reduce((departures, session) => [...departures, ...session.departures], []).reduce((cities, departure) => [...cities, departure.city], []).filter((value, index, self) => self.indexOf(value) === index)
    cities.sort()

    //console.log(holidayStay)

    return (
        <Link className={"vignette -type-1 h-100" + (targetSession?.availablePlaces === 0 ? ' opacity-50' : '')} href={createObjectPagePathname('HolidayStay', holidayStay) + (targetSession ? '?session=' + targetSession.id : '')}>
            <div className="vignette__image">
                <div className="cardImage">
                    <div className="cardImage__content">
                        {/*<img className="col-12" src={getMediaUrl(holidayStay.medias.medias[0]?.media.url ?? process.env.NEXT_PUBLIC_HOLIDAYSTAY_DEFAULTIMAGE)} alt="image" loading="lazy" />*/}
                        <Image
                            className="col-12"
                            src={getAsServerMediaUrl(holidayStay.medias.filter(media => media.mimeType.indexOf('image/') === 0)[0]?.url ?? '#')}
                            alt="image"
                            width={holidayStay.medias.filter(media => media.mimeType.indexOf('image/') === 0)[0]?.metadata.width}
                            height={holidayStay.medias.filter(media => media.mimeType.indexOf('image/') === 0)[0]?.metadata.height}
                            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                            quality={50}
                        />
                    </div>
                    {/*<div className="cardImage__wishlist">
                        <div >à faire en famille</div>
                    </div>*/}
                    <div className="cardImage__leftBadge">
                        <div className="tag">
                            <h3 className="tag-title">{holidayStay.minAge}{holidayStay.minAge !== holidayStay.maxAge && <>-{holidayStay.maxAge}</>} ans</h3>
                            <div className="tag-tail" />
                        </div>
                    </div>
                </div>
                <div className="bandeau d-flex justify-content-between">
                    <div>
                        <i className="fi fi-rr-camping" />
                        Séjour vacances
                    </div>
                    {targetSession && <div className="dates">{moment(targetSession.startDate).format('DD' + (moment(targetSession.startDate).format('M') !== moment(targetSession.endDate).format('M') ? ' MMM' : ''))}-{moment(targetSession.endDate).format('DD MMM')}</div>}
                </div>
            </div>
            <div className="vignette__content pt-10">
                <div className="d-flex flex-column justify-content-between h-100">
                    <div>
                        <div className="d-flex justify-content-between">
                            {holidayStay.accomodations.length > 0 &&
                                <div className="flex-fill">
                                    <p className="text-light-1 lh-14 text-13 mt-5 mb-0">
                                        <i className="fi fi-rr-marker text-primary-4" /> {holidayStay.accomodations[0].accomodation.address.city} ({holidayStay.accomodations[0].accomodation.address.postCode.slice(0, 2)})
                                    </p>
                                </div>
                            }
                            {availableSessions.length > 1 &&
                                <div className="info">
                                    D'autres sessions sont disponibles
                                </div>
                            }
                        </div>
                        <h4 className="vignette__title py-10">
                            {holidayStay.name}
                        </h4>
                        {holidayStay.environment in environments && <div className="type">{environments[holidayStay.environment].name}</div>}
                        {targetSession?.availablePlaces > 0 && cities.length > 0 &&
                            <>
                                <div className="tarif">à partir de {Math.floor(Math.min(...nextSessions.map(session => Math.min(...session.departures.map(departure => departure.price)))) / 100)}€ par enfant</div>
                                {/*<div className="tarif">{Math.floor(Math.min(...holidayStay.sessions[0].departures.map(departure => departure.price)))/100}€ par enfant</div>                        */}
                                <div className="lieudepart">
                                    Départ possible : {cities.join(', ')}
                                </div>
                            </>
                        }
                        {targetSession?.availablePlaces === 0 ?
                            <>
                                <div className="badge rounded-pill bg-terracotta fs-6 d-table mt-2">COMPLET</div>
                            </>
                            :
                            <>
                                {targetSession?.availablePlaces < 5 &&
                                    <div className="flex-fill">
                                        <p className="text-light-1 lh-14 text-13 mt-5 mb-0 last-chance">
                                            Dernière{targetSession?.availablePlaces > 1 && <>s</>} place{targetSession?.availablePlaces > 1 && <>s</>} disponible{targetSession?.availablePlaces > 1 && <>s</>}
                                        </p>
                                    </div>
                                }
                            </>
                        }
                    </div>

                    <div className="d-flex flex-column justify-content-end">
                        <div className="organisation d-flex items-start">
                            <div className="flex-center size-20 rounded-full bg-primary-3 mr-5 text-white">
                                <i className="fi fi-rr-home" />
                            </div>
                            <div className='lh-1 mb-5'>
                                Organisé par {getName(holidayStay.partnershipOf ? holidayStay.partnershipOf.proposedBy : holidayStay.proposedBy)}
                            </div>
                        </div>
                        {/*<div className="partenariat">
                            Séjour en partenariat avec la ligue de
                            l’Enseignement de Moselle et les Pep’Lor’est
                        <div>*/}
                    </div>

                </div>
            </div>
        </Link>
    )
}